import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ep-bt-journey-planner-proxy',
  template: `
    <p>
      ep-bt-journey-planner-proxy works!
    </p>
  `,
  styles: []
})
export class EpBtJourneyPlannerProxyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
